export interface SprintSpan {
  id: string;
  startDate: string;
  endDate: string;
}

const two = (value: number): string => String(value).padStart(2, '0');

// Not `dayKey`/`fullDate`: their module loads `@data`, which every test mocking it would then have to stub.
const localDayOf = (instant: Date): string =>
  `${instant.getFullYear()}-${two(instant.getMonth() + 1)}-${two(instant.getDate())}`;

const utcDayOf = (instant: Date): string =>
  `${instant.getUTCFullYear()}-${two(instant.getUTCMonth() + 1)}-${two(instant.getUTCDate())}`;

/** Whether an instant falls on a day the sprint covers, both ends included. Sprint days are midnight UTC. */
export const reportedInSprint = (reportedAt: string, sprint: SprintSpan): boolean => {
  const day = localDayOf(new Date(reportedAt));

  return utcDayOf(new Date(sprint.startDate)) <= day && day <= utcDayOf(new Date(sprint.endDate));
};

/** The sprints at least one of these incidents was reported in, so the picker offers no empty choice. */
export const sprintsWithIncidents = <T extends SprintSpan>(sprints: T[], reportedAts: string[]): T[] =>
  sprints.filter(sprint => reportedAts.some(at => reportedInSprint(at, sprint)));
